export default __webpack_public_path__ + "static/media/group-hra-ver-2.9015cecd.svg";